import e from "../../utils/classNames.js";
import t from "../fade/Fade.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/spinner/Spinner.tsx
var i = (t) => {
	let { isInverse: i, isDoubleSized: a, ...o } = t, s = e("spinner", i && "inverse", a && "double");
	return /* @__PURE__ */ r("div", {
		...o,
		className: s,
		children: [
			/* @__PURE__ */ n("div", {}),
			/* @__PURE__ */ n("div", {}),
			/* @__PURE__ */ n("div", {}),
			/* @__PURE__ */ n("div", {})
		]
	});
}, a = (a) => {
	let { isInverse: o = !1, isFullSized: s = !1, isFullScreen: c = !1, isDoubleSized: l = !1, isInline: u = !1, show: d = !1, text: f, ...p } = a, m = /* @__PURE__ */ n(i, {
		isDoubleSized: l,
		isInverse: o,
		...p
	});
	if (u) return m;
	let h = e("spinnerInfoBox display-flex justify-content-center align-items-center height-100pct", s && "fullsized", c && "fullscreen"), g = /* @__PURE__ */ r("div", {
		className: h,
		children: [m, f && /* @__PURE__ */ n("div", {
			className: "spinnerText",
			children: f
		})]
	});
	return c || s ? /* @__PURE__ */ n(t, {
		show: d,
		duration: .1,
		children: g
	}) : g;
};
//#endregion
export { a as default };

//# sourceMappingURL=Spinner.js.map